var React = require('react');

function Sky2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"id":"orbit2","d":"M51 131 C 60 118 66 109 75 99","fill":"none","stroke":"none","key":0}),React.createElement("path",{"pathLength":"200","transform":"scale(0.2)","d":"M50.5 101C78.3904 101 101 78.3904 101 50.5C101 22.6096 78.3904 0 50.5 0C22.6096 0 0 22.6096 0 50.5C0 78.3904 22.6096 101 50.5 101Z","fill":"#FFC907","key":1},React.createElement("animateMotion",{"dur":"2s","rotate":"auto","fill":"freeze"},React.createElement("mpath",{"xlinkHref":"#orbit2"})))]);
}

Sky2.defaultProps = {"viewBox":"0 0 500 300"};

module.exports = Sky2;

Sky2.default = Sky2;
